import * as types from './mutation-types'
import Vue from 'vue'
import { IMesureUniteState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMesureUnite, IAloDbMesureUniteConstParam } from '@/models/alodb/AloDbMesureUnite';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMesureUniteState> = {
     
    //Gestion des recherches de missions
    [types.MESUREUNITE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.MesureUnite.Title').toString()}).toString()
        state.mesureUniteLoading = true
    },
    [types.MESUREUNITE_SUCCESS]: (state, mesureUnites:Array<AloDbMesureUnite>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.MesureUnite.Title').toString()}).toString()
        state.mesureUnites = mesureUnites   
        state.mesureUniteLoading = false             
    },
    [types.MESUREUNITE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MesureUnite.Title').toString()}).toString()
        state.mesureUnites = []
        state.mesureUniteLoading = false
    },
    [types.MESUREUNITE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.MesureUnite.Title').toString()} ${itemId}`}).toString()
        state.mesureUniteLoading = true
    },
    [types.MESUREUNITE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MesureUnite.Title').toString()}).toString()
        state.mesureUniteLoading = false
    },
    [types.MESUREUNITE_SELECT_DETAIL_SUCCESS]: (state,mesureUnite:AloDbMesureUnite) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.MesureUnite.Title').toString()} ${mesureUnite.MUT_ID}`}).toString()        
        //1, on met à jour de m'mesureUnite dans la liste des mesureUnites
        const index = state.mesureUnites.findIndex(m => m.MUT_ID == mesureUnite.MUT_ID)
        state.mesureUnites.splice(index == -1 ? state.mesureUnites.length : index, index == -1 ? 0 : 1, mesureUnite)
        state.mesureUniteLoading = false
    },
    [types.MESUREUNITE_SELECT_DETAIL]: (state,mesureUnite:AloDbMesureUnite) => {                
        state.originalAdmMesureUnite = mesureUnite        
        state.modifiedAdmMesureUnite = new AloDbMesureUnite(mesureUnite)
    },
    [types.MESUREUNITE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.MesureUnite.Title').toString()} ${libelle}`}).toString()
        state.mesureUniteLoading = true
    },
    [types.MESUREUNITE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.MesureUnite.Title').toString()}).toString()
        state.mesureUniteLoading = false
    },
    [types.MESUREUNITE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmMesureUnite = {...state.modifiedAdmMesureUnite,...newProperties}
    },
    [types.MESUREUNITE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }           
}


export default mutations
